import { HTMLAttributes } from "react";
import { Panel } from "@/components/atoms";
import { clsx } from "@/utils";
import { SetupPanelHeader } from "../QuickSetup/common/components/SetupPanelHeader";

export interface StaticSetupPanelProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  stepNumber?: number;
  title: string | React.ReactNode;
  description: string;
  stepCount?: number;
  isOpen?: boolean;
  onToggle?: () => void;
  completedSteps?: number;
}

export const StaticSetupPanel = ({
  stepNumber,
  title,
  description,
  stepCount,
  isOpen = false,
  onToggle,
  completedSteps = 0,
  children,
  className,
  ...props
}: StaticSetupPanelProps) => {
  const showProgressBar = stepCount && completedSteps > 0;
  const progressPercentage = stepCount ? (completedSteps / stepCount) * 100 : 0;

  return (
    <Panel
      className={clsx("!p-0 transition-all duration-200", isOpen ? "!border-vivid-purple shadow-focus-ring-vivid-purple" : "", className)}
      data-panel-step={stepNumber}
      {...props}
    >
      <SetupPanelHeader
        stepNumber={stepNumber}
        title={title}
        description={description}
        stepCount={stepCount}
        isOpen={isOpen}
        isCompleted={completedSteps === stepCount && stepCount !== 0}
        showProgressBar={!!showProgressBar}
        progressPercentage={progressPercentage}
        onClick={onToggle}
      />

      <div
        className={clsx("grid transition-[grid-template-rows] duration-200 ease-in-out", isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]")}
      >
        <div className="overflow-hidden">
          <div className="flex flex-col gap-3 p-4">{children}</div>
        </div>
      </div>
    </Panel>
  );
};
